import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        baseUrl: String
    }


    /**
     * Handles the form submission via the Search Input
     * @param e
     */
    onSubmit(e) {
        e.preventDefault();
        const input = e.target.querySelector('input[name="search"]');
        this.update(input);
    }

    /**
     * Handles onChange live-filtering
     * @param e
     */
    onChange(e) {
        this.update(e.target);
    }

    update(target) {
        const {name, value, checked, type} = target;
        const currentPath = window.location.pathname.replace(/\/$/, "");
        const targetPath = this.hasBaseUrlValue ? this.baseUrlValue.replace(/\/$/, "") : currentPath;
        const isOnTargetPage = currentPath === targetPath;

        let url;
        let params;
        let frameTarget = "listing_results";

        if (isOnTargetPage) {
            url = new URL(window.location.href);
            params = url.searchParams;
        } else {
            url = new URL(window.location.origin + targetPath);
            params = url.searchParams;
            frameTarget = "_top";
        }
        params.delete('page');

        if (type === 'checkbox') {
            let currentValues = params.getAll(name);
            if (checked) {
                if (!currentValues.includes(value)) currentValues.push(value);
            } else {
                currentValues = currentValues.filter(v => v !== value);
            }
            params.delete(name);
            currentValues.forEach(v => params.append(name, v));
        } else {
            if (value && value.trim().length > 0) {
                params.set(name, value);
            } else {
                params.delete(name);
            }
        }

        Turbo.visit(url.toString(), {frame: frameTarget, action: "advance"});
    }
}